import { z } from 'zod'

export type LoginFormValues = {
  username: string
  password: string
}

export type LoginValues = LoginFormValues & {
  verifyToken: string
}

export const loginSchema = z.object({
  username: z.string({ message: 'Email is required' }).min(1).email({ message: 'Invalid email address' }),
  password: z.string({ message: 'Password is required' }).min(1),
})

export const loginDefaultValues = {
  username: '',
  password: '',
}

export const loginFields = {
  username: {
    fieldProps: {
      label: 'Email',
      name: 'username',
      type: 'email',
      required: true,
      autoComplete: 'email',
    },
    type: 'text',
  },
  password: {
    fieldProps: {
      label: 'Password',
      name: 'password',
      type: 'password',
      required: true,
      autoComplete: 'current-password',
    },
    type: 'password',
  },
} as const
